function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#263238;}\n\t.st1{fill:#40C4FF;}\n\t.st2{fill:#FFD740;}\n\t.st3{fill:#FF5252;}\n\t.st4{fill:#4DB6AC;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{fill:#4FC3F7;}\n\t");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Email_Transfer"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M49.5,58.5h-42C7.224,58.5,7,58.276,7,58V29c0-0.276,0.224-0.5,0.5-0.5S8,28.724,8,29v28.5h41V29 c0-0.276,0.224-0.5,0.5-0.5S50,28.724,50,29v29C50,58.276,49.776,58.5,49.5,58.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M49.5,58.5h-42c-0.193,0-0.37-0.112-0.452-0.287c-0.083-0.176-0.057-0.383,0.067-0.532l13.735-16.572 c0.087-0.105,0.213-0.17,0.349-0.18c0.15-0.009,0.271,0.037,0.371,0.128l6.93,6.269l6.93-6.269 c0.101-0.091,0.226-0.135,0.371-0.128c0.136,0.01,0.262,0.075,0.349,0.18l13.735,16.572c0.124,0.149,0.15,0.356,0.067,0.532 C49.87,58.388,49.693,58.5,49.5,58.5z M8.563,57.5h39.873L35.713,42.149l-6.878,6.222c-0.189,0.173-0.48,0.173-0.67,0 l-6.878-6.222L8.563,57.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M 28.5 48.5 C 28.364 48.5 28.228 48.444 28.129 48.335 C 27.944 48.13 27.96 47.814 28.164 47.629 L 48.755 29 L 49.836 28.629 C 49.94 28.724 50 28.859 50 29 C 50 29.141 49.94 29.276 49.836 29.371 L 28.836 48.371 C 28.74 48.458 28.62 48.5 28.5 48.5 Z"
})), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M 28.5 48.5 C 28.38 48.5 28.26 48.458 28.164 48.371 L 7.164 29.371 C 7.06 29.276 7 29.141 7 29 C 7 28.859 7.06 28.696 7.165 28.601 L 49.884 28.524 L 28.836 47.629 C 29.04 47.814 29.056 48.13 28.871 48.335 C 28.772 48.444 28.636 48.5 28.5 48.5 Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M40.5,62.5h-1c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h1c0.276,0,0.5,0.224,0.5,0.5 S40.776,62.5,40.5,62.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M37.5,62.5h-21c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h21c0.276,0,0.5,0.224,0.5,0.5 S37.776,62.5,37.5,62.5z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -20.591759, 20.117781)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "st4",
  cx: 49.02,
  cy: 13.069,
  r: 7.5
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -20.13846, 23.789686)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M47.586,12.329c-0.133,0-0.26-0.053-0.354-0.146l-2.828-2.829c-0.195-0.195-0.195-0.512,0-0.707 s0.512-0.195,0.707,0l2.475,2.475l4.95-4.95c0.195-0.195,0.512-0.195,0.707,0s0.195,0.512,0,0.707l-5.304,5.303 C47.846,12.276,47.719,12.329,47.586,12.329z"
})));

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Set",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email.9f34c655.svg";
export { ForwardRef as ReactComponent };